
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getProvince} from 'sr/utils/api/masterData/province/getProvince'
export const fetchprovince = createAsyncThunk(
  'getProvince',
  async () => {
    const response = await getProvince()
    return response?.data
  }
)


